import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import FileUploadedPage from './FileUploadedPage';

interface FileUploadedPageWrapperProps {
  t?: any;
}

const FileUploadedPageWrapper: React.FC<FileUploadedPageWrapperProps> = ({ t }) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Get navigation parameters from URL query strings (match reference navigation.getParam)
  const urlParams = new URLSearchParams(location.search);
  const leave_id = urlParams.get('leave_id');
  const children_id = urlParams.get('children_id');
  const is_submit_missing_note = urlParams.get('is_submit_missing_note') === 'true';

  // Basic navigation functions
  const handleNavigate = (path: string, params?: any) => {
    if (params) {
      const searchParams = new URLSearchParams();
      Object.keys(params).forEach(key => {
        if (params[key] !== null && params[key] !== undefined) {
          searchParams.set(key, String(params[key]));
        }
      });
      navigate(`${path}?${searchParams.toString()}`);
    } else {
      navigate(path);
    }
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <FileUploadedPage
      t={t}
      navigate={handleNavigate}
      goBack={handleGoBack}
      // Pass navigation parameters as props (match reference)
      leave_id={leave_id}
      children_id={children_id}
      is_submit_missing_note={is_submit_missing_note}
    />
  );
};

export default withTranslation()(FileUploadedPageWrapper);